module.exports = __webpack_public_path__ + "img/exercise-routine.6ed8716b.svg";